import Routers from './Route';
import AnimationThemeProvider from './_helper/AnimationTheme/AnimationThemeProvider';
import CustomizerProvider from './_helper/Customizer/CustomizerProvider';
import { LoaderProvider } from './_helper/LoaderContext';
import { ClinicProvider } from './_helper/ClinicProvider';
import { PrivilegeContextProvider } from './_helper/PrivilegeContext';
import { NotificationProvider } from './_helper/NotificationContext';
import { BrowserRouter } from 'react-router-dom';
import { SocketProvider } from './_helper/SocketProvider';
import { PharmacyProvider } from './_helper/PharmacyProvider';
const App = () => {

  return (
    <div className='App'>
      <BrowserRouter basename="/">
        <CustomizerProvider>
          <AnimationThemeProvider>
            <ClinicProvider>
              <PharmacyProvider>
                <PrivilegeContextProvider>
                  <LoaderProvider>
                    <NotificationProvider>
                      {/* <SocketProvider> */}
                        <Routers />
                      {/* </SocketProvider> */}
                    </NotificationProvider>
                  </LoaderProvider>
                </PrivilegeContextProvider>
              </PharmacyProvider>
            </ClinicProvider>
          </AnimationThemeProvider>
        </CustomizerProvider>
      </BrowserRouter>
    </div>
  )
};

export default App;
